import React from "react"

import StoryblokLink from "../shared/StoryblokLink"

import { renderCardHeadline } from "../contentEdit"

import { WhitepaperContent } from "../../types"

type CaseStudyItemProps = {
  full_slug: string
  content: WhitepaperContent
}

const WhitepaperItem = ({ full_slug, content }: CaseStudyItemProps) => {
  const linkObject = {
    cached_url: full_slug,
    linktype: "story",
  }

  const cardHeadline = renderCardHeadline(
    content?.title,
    "c-learnItem__heading"
  )

  return (
    <StoryblokLink to={linkObject} className="c-learnItem d-flex flex-column">
      <div className="c-learnItem__hoverWrapper">
        <div
          className="c-learnItem__imageWrapper"
          style={{ backgroundImage: `url(${content?.image.filename})` }}
        />

        <div className="c-learnItem__content">
          <span className="c-learnItem__type">{content?.component}</span>

          {cardHeadline}

          <span className="btn-tertiary hover-bcgUnderline">Read more</span>
        </div>
      </div>
    </StoryblokLink>
  )
}

export default WhitepaperItem
